import { ensureBool } from "igniteui-react-core";
/**
 * Contains PieChart label click event data.
*/
var IgrLabelClickEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrLabelClickEventArgs() {
    }
    Object.defineProperty(IgrLabelClickEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrLabelClickEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrLabelClickEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrLabelClickEventArgs.prototype, "item", {
        /**
         * Gets the slice data context.
        */
        get: function () {
            return this.i.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrLabelClickEventArgs.prototype, "allowSliceClick", {
        /**
         * Gets and sets whether or not the owning pie chart should fire its SliceClick event
        */
        get: function () {
            return this.i.allowSliceClick;
        },
        set: function (v) {
            this.i.allowSliceClick = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrLabelClickEventArgs;
}());
export { IgrLabelClickEventArgs };
